<div class="fr-report-container" [class.print-mode]="isPrintMode">
  <div class="fr-report-body">
  @if (isPrintView) {
  <app-print-preview-bar
    viewName="FR Report"
    [studyName]="studyName"
    [contextLine]="printContextLine"
    [tableColumns]="tableColumns"
    [columnSelectionMode]="'assayBead'"
    (selectColumns)="handlePrintColumnSelection($event)"></app-print-preview-bar>
  }

  <div class="fr-report-scroll bpx-report">
    <!--
      The printed report keeps its plain stacked identification block; on screen the same five
      values read as a card, matching the identification blocks on the other tabs.
    -->
    @if (isPrintView) {
    <div class="bpx-print-only">
      <div class="fr-report-meta">
        Panel Name: <span>{{ panelName || '-' }}</span><br />
        Run Type: <span>{{ runType || '-' }}</span><br />
        Test Spec: <span>{{ testSpec || '-' }}</span><br />
        Assignment Spec: <span>Final</span><br />
        Operator: <span>{{ operatorName || '-' }}</span>
      </div>
    </div>

    <div class="bpx-detail fr-report-detail bpx-screen-only">
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Panel Name</span>
        <span class="bpx-detail__value">{{ panelName || '-' }}</span>
      </div>
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Run Type</span>
        <span class="bpx-detail__value">{{ runType || '-' }}</span>
      </div>
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Test Spec</span>
        <span class="bpx-detail__value">{{ testSpec || '-' }}</span>
      </div>
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Assignment Spec</span>
        <span class="bpx-detail__value">Final</span>
      </div>
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Operator</span>
        <span class="bpx-detail__value">{{ operatorName || '-' }}</span>
      </div>
    </div>
    } @else {
    <div class="bpx-detail fr-report-detail">
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Panel Name</span>
        <span class="bpx-detail__value">{{ panelName || '-' }}</span>
      </div>
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Run Type</span>
        <span class="bpx-detail__value">{{ runType || '-' }}</span>
      </div>
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Test Spec</span>
        <span class="bpx-detail__value">{{ testSpec || '-' }}</span>
      </div>
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Assignment Spec</span>
        <span class="bpx-detail__value">Final</span>
      </div>
      <div class="bpx-detail__item">
        <span class="bpx-detail__label">Operator</span>
        <span class="bpx-detail__value">{{ operatorName || '-' }}</span>
      </div>
    </div>
    }

    <div class="toggle-links-box" *ngIf="!isPrintView">
      <button type="button" class="bpx-btn" [disabled]="(isStudySaved$ | async) !== true" (click)="navigateToPrintView()">
        <mat-icon fontIcon="print"></mat-icon>
        <span>Print View</span>
      </button>
    </div>

    @if (isPrintView && isPrintMode) {
    @for (pageColumns of printPages; track trackByPage; let pageIndex = $index) {
    <div class="bpx-print-page" [class.bpx-print-page--last]="pageIndex === (printPages.length - 1)">
      @if (printPageCaption(pageIndex)) {
      <div class="bpx-print-page-caption">{{ printPageCaption(pageIndex) }}</div>
      }
      <ng-container *ngTemplateOutlet="frReportTable; context: { $implicit: pageColumns }"></ng-container>
    </div>
    }
    } @else {
    <ng-container *ngTemplateOutlet="frReportTable; context: { $implicit: columns }"></ng-container>
    }

    <ng-template #frReportTable let-pageColumns>
    <table class="bpx-report__table bpx-report__table--pin-first bpx-report__table--sticky-head fr-report-table">
      <thead class="bpx-report__head">
        <tr>
          <td class="row-label">Assay Name</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ column.assay || '-' }}</td>
          </ng-container>
        </tr>
        <tr>
          <td class="row-label">Bead Region</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ column.region }}</td>
          </ng-container>
        </tr>
        <tr>
          <td class="row-label">Units</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ column.units || '-' }}</td>
          </ng-container>
        </tr>
        <tr>
          <td class="row-label">Result Decimal Precision</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ column.resultDecimalPrecision }}</td>
          </ng-container>
        </tr>
        <tr>
          <td class="row-label">User Defined Decimal Precision</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ column.userDefinedDecimalPrecision }}</td>
          </ng-container>
        </tr>
        <tr>
          <td class="row-label">Result Type</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ column.resultType || '-' }}</td>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr class="section-header bpx-report__section">
          <td class="row-label">Calibrator Assignment</td>
          <td [attr.colspan]="pageColumns.length || 1"></td>
        </tr>
        <tr *ngFor="let level of calibratorRows">
          <td class="row-label">{{ level }}</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ getCalibratorAssignment(column, level) }}</td>
          </ng-container>
        </tr>
        <tr class="section-header bpx-report__section">
          <td class="row-label">Calibrator (Avg RFI)</td>
          <td [attr.colspan]="pageColumns.length || 1"></td>
        </tr>
        <tr *ngFor="let level of calibratorRows">
          <td class="row-label">{{ level }}</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ getAverageRfi(column, level) }}</td>
          </ng-container>
        </tr>
        <tr class="section-header bpx-report__section">
          <td class="row-label">Calibrator (Avg FR)</td>
          <td [attr.colspan]="pageColumns.length || 1"></td>
        </tr>
        <tr *ngFor="let level of calibratorRows">
          <td class="row-label">{{ level }}</td>
          <ng-container *ngFor="let column of pageColumns; trackBy: trackByColumn">
            <td>{{ getAverageFr(column, level) }}</td>
          </ng-container>
        </tr>
      </tbody>
        <tfoot class="bpx-print-spacer-footer">
          <tr>
            <td [attr.colspan]="(pageColumns.length || 0) + 1">
              <div class="bpx-print-footer-spacer" aria-hidden="true"></div>
            </td>
          </tr>
        </tfoot>
    </table>
    </ng-template>
  </div>
  <div class="fr-report-print-footer">
    <div>{{ studyName || '-' }}</div>
    <div>{{ panelName || '-' }} : Spec Rev {{ specVersion || '-' }}</div>
    <div>Web App Version: {{ appVersion || '-' }}</div>
  </div>
  </div>
</div>
